class Accordion extends HTMLElement {
  constructor() {
    super();
    this.accordionOpen = this.accordionOpen.bind(this);
  }

  accordionOpen() {
    this.toggle = this.querySelector('[data-accordion-toggle]');
    this.description = this.querySelector('[data-accordion-content]');

    if (!this.toggle || !this.description) return;

    this.description.style.maxHeight = '0px';

    this.toggle.addEventListener('click', () => {
      const accordionIcon = this.querySelector('.accordion__title-icon');

      if (accordionIcon) {
        accordionIcon.textContent = accordionIcon.textContent === '+' ? '–' : '+';
      }
      this.toggle.classList.toggle('active');

      this.querySelector('.accordion__description').setAttribute('aria-expanded', accordionIcon.textContent !== '+');
      this.querySelector('button[data-accordion-toggle]').setAttribute(
        'aria-expanded',
        accordionIcon.textContent !== '+',
      );

      if (this.description.style.maxHeight === '0px' || this.description.style.maxHeight === '') {
        this.description.style.maxHeight = `${this.description.scrollHeight}px`;
        this.description.classList.remove('invisible');
      } else {
        this.description.style.maxHeight = '0px';
        this.description.classList.add('invisible');
      }
    });
  }

  connectedCallback() {
    this.accordionOpen();
  }
}

const init = () => {
  if (!customElements.get('accordion-item')) {
    customElements.define('accordion-item', Accordion);
  }
};

init();
